WYATT.registerComponent(
  "wyatt-carousel",
  class Carousel extends HTMLElement {
    constructor() {
      super();

      this.currentIndex = 0;
    }

    connectedCallback() {
      this.controlButtons = this.querySelectorAll(
        "[data-carousel-control-button]"
      );
      this.paginationButtons = this.querySelectorAll(
        "[data-carousel-pagination-button]"
      );
      this.primaryCarousel = this.querySelector('[data-carousel="primary"]');
      this.paginationCarousel = this.querySelector(
        '[data-carousel="pagination"]'
      );

      this.slideCount =
        this.primaryCarousel.querySelectorAll("[data-slide]").length;

      this.bindEvents();
      this.updateCarouselClass(this.currentIndex, this.currentIndex);
    }

    bindEvents() {
      this.controlButtons.forEach((button) => {
        button.addEventListener("click", this.handleControlClick.bind(this));
      });

      this.paginationButtons.forEach((button) => {
        button.addEventListener("click", this.handlePaginationClick.bind(this));
      });

      this.primaryCarousel.addEventListener(
        "scroll",
        WYATT.debounce((event) => {
          this.handleScroll(event);
        }, 300).bind(this)
      );

      this.primaryCarousel.querySelectorAll("[data-slide]").forEach((slide) => {
        slide.addEventListener("click", this.handleSlideClick.bind(this));
      });
    }

    handleControlClick(event) {
      const button = event.currentTarget;
      const direction = button.dataset.carouselControlButton;
      const newIndex =
        direction === "next" ? this.currentIndex + 1 : this.currentIndex - 1;

      this.goTo([this.primaryCarousel, this.paginationCarousel], newIndex);
    }

    handlePaginationClick(event) {
      const button = event.currentTarget;
      const newIndex = parseInt(button.dataset.carouselPaginationButton, 10);

      this.goTo([this.primaryCarousel], newIndex);
    }

    handleSlideClick(event) {
      // Users often try to click anywhere on the slide—not just the CTA.
      // To make the experience smoother, we simulate a click on the CTA
      // if there's exactly one link present in the slide.
      const slide = event.currentTarget;
      const ctas = slide.querySelectorAll("a");

      if (ctas.length !== 1) {
        return;
      }

      ctas[0].click();
    }

    handleScroll(event) {
      const carousel = event.target;
      const position = carousel.scrollLeft;
      const slideWidth = carousel.querySelector(
        "[data-slide]:not(.hidden)"
      ).offsetWidth;
      const newIndex = Math.floor(position / slideWidth);

      if (newIndex === this.currentIndex) {
        return;
      }

      event.preventDefault();

      this.goTo([this.paginationCarousel], newIndex);
    }

    updatePaginationButtons(newIndex) {
      if (!this.paginationCarousel) {
        return;
      }

      const currentButton = this.querySelector(
        `[data-carousel-pagination-button="${this.currentIndex}"]`
      );
      const newButton = this.querySelector(
        `[data-carousel-pagination-button="${newIndex}"]`
      );

      currentButton.classList.remove("carousel__slide--current");
      newButton.classList.add("carousel__slide--current");
    }

    updateControlButtons() {
      this.controlButtons.forEach((button) => {
        const direction = button.dataset.carouselControlButton;

        if (direction === "previous" && this.currentIndex === 0) {
          button.disabled = true;
        } else if (
          direction === "next" &&
          this.currentIndex === this.slideCount - 1
        ) {
          button.disabled = true;
        } else {
          button.disabled = false;
        }
      });
    }

    updateCarouselClass(currentIndex, newIndex) {
      this.classList.remove(`carousel--at-slide-${currentIndex}`);
      this.classList.add(`carousel--at-slide-${newIndex}`);
    }

    goTo(carousels, newIndex) {
      carousels.forEach((carousel) => {
        if (carousel) {
          const newSlide = carousel.querySelector(`[data-slide="${newIndex}"]`);
          const width = newSlide.offsetWidth;
          const slideDifference = newIndex - this.currentIndex;

          carousel.scrollBy(width * slideDifference, 0);
        }
      });

      this.updateCarouselClass(this.currentIndex, newIndex);
      this.updatePaginationButtons(newIndex);
      this.currentIndex = newIndex;
      this.updateControlButtons();
    }
  }
);
